var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var ApplicationRepository_1;
import { ICacheDataSourceType } from '../../../Data/DataSource/CacheDataSource/ICacheDataSource';
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { Observable } from '../../Observable/Observable';
import { CoreConfig } from '../../../CoreConfig';
import queryString from 'query-string';
import { Platform } from 'react-native';
let ApplicationRepository = ApplicationRepository_1 = class ApplicationRepository {
    constructor(cacheDataSource, dataSource) {
        this.cacheDataSource = cacheDataSource;
        this.dataSource = dataSource;
        this.applicationParams = new Observable({});
        this.applicationToken = new Observable('');
        this.modules = new Observable([CoreConfig.moduleName.toLowerCase()]);
        this.version = new Observable(null);
        this.fonts = [];
        this.networkMode = new Observable({
            is_maintenance: false,
            is_offline: false,
            can_request: true
        });
        this.dataSource.setOnMaintenanceMode(offline => {
            if (offline) {
                if (this.maintenanceTimeout || this.networkMode.value.is_maintenance) {
                    return;
                }
                this.maintenanceTimeout = setTimeout(() => {
                    this.networkMode.update({ can_request: true });
                }, 300000);
                this.networkMode.update({ is_maintenance: true, can_request: false });
            }
            else {
                if (!this.networkMode.value.is_maintenance) {
                    return;
                }
                this.networkMode.update({ is_maintenance: false, can_request: true });
            }
        });
        this.dataSource.setOnOfflineMode(is_offline => {
            if (is_offline !== this.networkMode.value.is_offline) {
                this.networkMode.update({ is_offline });
            }
        });
        this.networkMode.observe(this, value => {
            this.dataSource.setMaintenanceMode(!value.can_request);
        });
        this.dataSource.addInterceptor(value => {
            var _a, _b, _c, _d;
            if (Array.isArray(value.error) && ((_a = value.error) === null || _a === void 0 ? void 0 : _a.find(err => err.code == 5118))) {
                return;
            }
            if (!((_b = value.meta) === null || _b === void 0 ? void 0 : _b.new_version)) {
                this.version.value && this.version.next(null);
            }
            else if (!this.version.value) {
                this.version.next((_c = value.meta) === null || _c === void 0 ? void 0 : _c.new_version);
            }
            else if (this.version.value.force_update !== value.meta.new_version.force_update) {
                this.version.next((_d = value.meta) === null || _d === void 0 ? void 0 : _d.new_version);
            }
        });
    }
    getNetworkMode() {
        return this.networkMode;
    }
    isNetworkUnavailable() {
        const mode = this.networkMode.value;
        return mode.is_maintenance || mode.is_offline;
    }
    addOnLogExceptionErrorHandler(fn) {
        return this.dataSource.addOnLogExceptionErrorHandler(fn);
    }
    getExceptions() {
        const value = this.cacheDataSource.getCache(ApplicationRepository_1.exception_key, []).data.value || [];
        return Promise.resolve(value);
    }
    addExceptions(exceptions) {
        return this.getExceptions()
            .then(old_exceptions => this.cacheDataSource.updateCache(ApplicationRepository_1.exception_key, [...old_exceptions, ...exceptions]))
            .then(res => res.value);
    }
    logExceptions(exceptions, disable_submit_error) {
        return this.dataSource.batchLogException(exceptions, disable_submit_error);
    }
    logException(exception) {
        return this.dataSource.logException(exception);
    }
    clearExceptions() {
        return this.cacheDataSource.removeCache(ApplicationRepository_1.exception_key);
    }
    getNewAppVersion() {
        return this.version;
    }
    preloadFonts(fonts) {
        if (Platform.OS === 'web') {
            return Promise.resolve(fonts);
        }
        const newFonts = fonts.map(x => (Object.assign({}, x)));
        const allLinks = newFonts.reduce((acc, font) => {
            Object.entries(font).forEach(([property, url]) => {
                if (property === 'name' || property === 'stylesheet') {
                    return;
                }
                acc.push({ key: this.getFontKey(font.name, property), name: font.name, property, url });
            });
            return acc;
        }, []);
        return this.cacheDataSource.downloadMany(allLinks, { overwrite: [{ key: 'application/vnd.ms-opentype', value: 'font/otf' }] })
            .then(downloads => {
            downloads.forEach(value => {
                if (value === null || value === void 0 ? void 0 : value.filename) {
                    const link = allLinks.find(x => x.key === value.key);
                    if (link) {
                        link.url = value.filename;
                    }
                }
            });
            newFonts.forEach(font => {
                allLinks.forEach(link => {
                    if (link.name !== font.name) {
                        return;
                    }
                    if (!this.hasFont(link.key)) {
                        this.fonts.push(link.key);
                    }
                    font[link.property] = link.url;
                });
                !this.hasFont(font.name) && this.fonts.push(font.name);
            });
            return newFonts;
        });
    }
    removeCache(key) {
        return this.cacheDataSource.removeCache(key);
    }
    preloadCache() {
        return this.cacheDataSource.preloadCache();
    }
    setShareLinkConfiguration(data) {
        var _a, _b;
        if ((_a = data.website) === null || _a === void 0 ? void 0 : _a.endsWith('/')) {
            data.website = data.website.slice(0, data.website.length - 1);
        }
        if ((_b = data.shareWebsite) === null || _b === void 0 ? void 0 : _b.endsWith('/')) {
            data.shareWebsite = data.shareWebsite.slice(0, data.shareWebsite.length - 1);
        }
        this.shareLinkConfiguration = data;
        return data;
    }
    resolveShareLink(link) {
        if (link.includes('deeplink_path')) {
            const params = queryString.parse(link.split('?').pop() || '');
            const new_link = params.$deeplink_path;
            if (new_link) {
                const route = new_link.split('/').pop();
                const screen = (route === null || route === void 0 ? void 0 : route.split('?')[0]) || '';
                const params = queryString.parse((route === null || route === void 0 ? void 0 : route.split('?')[1]) || '');
                return Promise.resolve({
                    url: new_link,
                    screen,
                    params
                });
            }
        }
        return fetch(link, { method: 'HEAD' })
            .then(val => {
            if (val.url.includes('deeplink_path')) {
                return this.resolveShareLink(val.url);
            }
            const route = val.url.split('/').pop();
            const screen = (route === null || route === void 0 ? void 0 : route.split('?')[0]) || '';
            const params = queryString.parse((route === null || route === void 0 ? void 0 : route.split('?')[1]) || '');
            return {
                url: val.url,
                screen,
                params
            };
        });
    }
    createShareLink(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        if (!((_a = this.shareLinkConfiguration) === null || _a === void 0 ? void 0 : _a.website)) {
            return Promise.reject(new Error('Link can\'t be created!'));
        }
        if (!((_b = this.shareLinkConfiguration) === null || _b === void 0 ? void 0 : _b.apiKey)) {
            const link = `${(_c = this.shareLinkConfiguration) === null || _c === void 0 ? void 0 : _c.website}/${data.screen}?${queryString.stringify(data.query || {})}`;
            if ((_d = this.shareLinkConfiguration) === null || _d === void 0 ? void 0 : _d.shareWebsite) {
                const query = {
                    link,
                    apn: this.shareLinkConfiguration.packageName,
                    afl: this.shareLinkConfiguration.googleStoreLink,
                    amv: this.shareLinkConfiguration.minAppVersion,
                    ibi: this.shareLinkConfiguration.bundleID,
                    ifl: this.shareLinkConfiguration.appStoreLink,
                    isi: this.shareLinkConfiguration.appStoreID,
                    st: (_e = data.params) === null || _e === void 0 ? void 0 : _e.title,
                    sd: (_f = data.params) === null || _f === void 0 ? void 0 : _f.description,
                    si: (_g = data.params) === null || _g === void 0 ? void 0 : _g.image,
                };
                const newLink = `${(_h = this.shareLinkConfiguration) === null || _h === void 0 ? void 0 : _h.shareWebsite}/?${queryString.stringify(query)}`;
                return new Promise(res => {
                    fetch(newLink, { method: 'HEAD' })
                        .then((response) => {
                        if (!response.ok) {
                            return Promise.reject(new Error(response.statusText));
                        }
                        return res({
                            shortLink: newLink,
                            previewLink: newLink
                        });
                    })
                        .catch(error => {
                        this.debugShareLinkError(query, error);
                        return res({
                            shortLink: link,
                            previewLink: link
                        });
                    });
                });
            }
            return Promise.resolve({
                shortLink: link,
                previewLink: link
            });
        }
        const value = {
            dynamicLinkInfo: {
                domainUriPrefix: (_j = this.shareLinkConfiguration) === null || _j === void 0 ? void 0 : _j.shareWebsite,
                link: `${(_k = this.shareLinkConfiguration) === null || _k === void 0 ? void 0 : _k.website}/${data.screen}?${queryString.stringify(data.query || {})}`,
                androidInfo: {
                    androidPackageName: (_l = this.shareLinkConfiguration) === null || _l === void 0 ? void 0 : _l.packageName,
                    androidMinPackageVersionCode: (_m = this.shareLinkConfiguration) === null || _m === void 0 ? void 0 : _m.minAppVersion,
                    androidFallbackLink: (_o = this.shareLinkConfiguration) === null || _o === void 0 ? void 0 : _o.googleStoreLink,
                },
                iosInfo: {
                    iosBundleId: (_p = this.shareLinkConfiguration) === null || _p === void 0 ? void 0 : _p.bundleID,
                    iosFallbackLink: (_q = this.shareLinkConfiguration) === null || _q === void 0 ? void 0 : _q.appStoreLink,
                    iosAppStoreId: (_r = this.shareLinkConfiguration) === null || _r === void 0 ? void 0 : _r.appStoreID,
                },
                socialMetaTagInfo: {
                    socialTitle: (_s = data.params) === null || _s === void 0 ? void 0 : _s.title,
                    socialDescription: (_t = data.params) === null || _t === void 0 ? void 0 : _t.description,
                    socialImageLink: (_u = data.params) === null || _u === void 0 ? void 0 : _u.image,
                }
            }
        };
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(value)
        };
        return new Promise(res => {
            var _a;
            fetch(`https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${(_a = this.shareLinkConfiguration) === null || _a === void 0 ? void 0 : _a.apiKey}`, params)
                .then(response => {
                if (!response.ok) {
                    return Promise.reject(new Error(response.statusText));
                }
                return response.json();
            })
                .then(res)
                .catch(error => {
                this.debugShareLinkError(value, error);
                return res({
                    shortLink: value.dynamicLinkInfo.link,
                    previewLink: value.dynamicLinkInfo.link
                });
            });
        });
    }
    debugShareLinkError(params, error) {
        console.debug({
            type: 'share_link_error',
            data: { params, error }
        });
    }
    getModules() {
        return this.modules;
    }
    registerModule(module) {
        if (this.modules.value.includes(module.toLowerCase())) {
            return this.modules;
        }
        return this.modules.next([...this.modules.value, module.toLowerCase()]);
    }
    getFontKey(name, weight) {
        return `${name.toLowerCase()}_${weight.toLowerCase()}`;
    }
    getFontFamily(fontName) {
        const fontKeys = ['light', 'light_italic', 'regular', 'regular_italic', 'medium', 'medium_italic', 'semibold', 'semibold_italic', 'bold_italic', 'bold'];
        return fontKeys.reduce((acc, key) => {
            const name = this.getFontKey(fontName, key);
            if (this.hasFont(name)) {
                acc[key] = name;
            }
            return acc;
        }, {});
    }
    createFont(font) {
        const name = font.name.toLowerCase();
        const fontFamily = Object.entries(font).reduce((acc, [key, value]) => {
            if (key === 'name') {
                return acc;
            }
            if (key === 'stylesheet') {
                return acc;
            }
            const fontName = this.getFontKey(name, key);
            acc[fontName] = value;
            return acc;
        }, {});
        if (font.regular) {
            fontFamily[name] = font.regular;
        }
        return fontFamily;
    }
    setApplicationToken(value) {
        return this.applicationToken.next(value);
    }
    getApplicationToken() {
        return this.applicationToken;
    }
    setInitParams(value) {
        var _a;
        if (!value) {
            value = {};
        }
        if (!value.icons) {
            value.icons = {
                config: require('../../../Assets/Icons/config.json'),
                name: 'icons',
                fileName: 'icons.ttf',
                file: require('../../../Assets/Icons/icons.ttf')
            };
        }
        (_a = value.fonts) === null || _a === void 0 ? void 0 : _a.forEach(font => !this.hasFont(font.name) && this.fonts.push(font.name));
        this.applicationParams.next(value || {});
        return this.applicationParams;
    }
    getFonts() {
        return this.fonts;
    }
    hasFont(font) {
        return this.getFonts().includes(font);
    }
    getIcons() {
        return this.applicationParams.value.icons;
    }
};
ApplicationRepository.exception_key = 'exceptions';
ApplicationRepository = ApplicationRepository_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(ICacheDataSourceType)),
    __param(1, inject(IAPIHTTPDataSourceType)),
    __metadata("design:paramtypes", [Object, Object])
], ApplicationRepository);
export { ApplicationRepository };
